module.exports = __webpack_public_path__ + "media/1.a9b8899c.mp3";